module.exports = __webpack_public_path__ + "static/media/icon-linkedin.fd9e7494.svg";